import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment-timezone';
import TranslationProvider from '../../../providers/TranslationProvider';
import FavoritesBanner from './FavoritesBanner';
import FavoriteVenueCard from '../../FavoriteVenueCard';

import './FavoritesView.scss';
import '../AccountPage.scss';

const FavoritesView = ({
  isMarketable,
  favorited,
  restaurants,
  toggleIsMarketable,
  isMobile,
  onFavoriteClick,
  loading,
  event,
  selectedDate,
}) => {
  const renderHeading = () => (
    <TranslationProvider translationKey="my_hit_list">
      <h2 className="AccountPage__title">
        My Hit List
      </h2>
    </TranslationProvider>
  );

  if (loading) {
    return renderHeading();
  }

  if (!restaurants.length) {
    return (
      <>
        {renderHeading()}
        <TranslationProvider translationKey="empty_hit_list">
          <span>There is nothing on your Hit List.</span>
        </TranslationProvider>
      </>
    );
  }

  return (
    <div className="FavoritesView AccountPage">
      <FavoritesBanner
        toggleIsMarketable={toggleIsMarketable}
        isMarketable={isMarketable}
      />
      {renderHeading()}
      <div className="FavoritesView__venue-container">
        {restaurants.map((restaurant) => (
          <FavoriteVenueCard
            key={restaurant.venue.id}
            venue={{
              ...restaurant.venue,
              image: restaurant?.venue?.images?.[0],
              favorite: favorited.includes(restaurant.venue.id),
              slots: [],
            }}
            isMobile={isMobile}
            onFavoriteClick={onFavoriteClick}
            event={event}
            selectedDate={selectedDate}
          />
        ))}
      </div>
    </div>
  );
};

FavoritesView.propTypes = {
  toggleIsMarketable: PropTypes.func.isRequired,
  isMarketable: PropTypes.bool.isRequired,
  favorited: PropTypes.arrayOf(PropTypes.number),
  restaurants: PropTypes.arrayOf(PropTypes.shape({
    venue: PropTypes.shape({
      priceRange: PropTypes.number,
      rating: PropTypes.number,
      name: PropTypes.string,
      images: PropTypes.arrayOf(PropTypes.string),
      collections: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,
  })).isRequired,
  onFavoriteClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  loading: PropTypes.bool,
  event: PropTypes.func.isRequired,
  selectedDate: PropTypes.string,
};

FavoritesView.defaultProps = {
  favorited: undefined,
  isMobile: false,
  loading: false,
  selectedDate: moment().format('YYYY-MM-DD'),
};

FavoritesView.displayName = 'FavoritesView';
export default FavoritesView;
